import { useCurrentRefinements } from 'react-instantsearch'

const NoOfFilters = (props: any) => {
  const { items } = useCurrentRefinements()
  const { hideIfZero } = props || {}
  const numberOfFilters = items[0]?.refinements?.length || 0
  if (hideIfZero && numberOfFilters == 0) return <></>

  return (
    <>
      <div className="body-3-bold h-4 w-4 rounded-full bg-ui-darkest-grey text-center text-white">
        {numberOfFilters}
      </div>
    </>
  )
}

export default NoOfFilters
